import * as App from '../../app';
import bridge from '@vkontakte/vk-bridge';
export function vkWebAppStorageSet(key, value) {
    if (FOR_VK) {
        bridge
            .send('VKWebAppStorageSet', { key: key, value: JSON.stringify(value) })
            .then(function (res) {
            if (DEVELOPMENT) {
                console.log('VKWebAppStorageSet:', res);
            }
        })
            .catch(function (err) {
            App.stat.error(err);
        });
    }
}
